// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2024 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

import { IJSONSchema } from '@glittr/frontend-core/src/plugins/validation/IJSONSchema';

const schema = {
  $id: '/submit-test-result-request-schema',
  type: 'object',
  required: ['projectId', 'workItemId'],
  properties: {
    result: {
      enum: [
        0,
        1,
      ],
    },
    bugSummary: {
      type: 'string',
      nullable: true,
    },
    description: {
      type: 'string',
      nullable: true,
    },
    projectId: {
      type: 'string',
      format: 'uuid',
    },
    workItemId: {
      type: 'integer',
    },
  },
} as IJSONSchema;

export default schema;
